export const getModelHierarchy = `query GetModelHrchyDetails($filter: ModelHrchyRequest!) {
  getModelHrchyDetails(filter: $filter) {
    modelHrchyDetails {
      region
      kmatId
      category
      series
      modelName
      subCategory
      lastModBy
      lastModifiedDate
    }
    categoryList
    seriesList
    subCategoryList
    selectedCategory
    selectedSeries
    selectedSubCategory
    affectedConfigIdsCount
  }
}`

export const updateModelHierarchy = `mutation ModelHierarchy($input: ModelHierarchyReq!) {
    ModelHierarchy (input: $input){
        model_name
        sub_category
        last_modified_ts
        last_modified_by
        Status
        category
        Message
        series
        kmat_id
        region
    }
}`

 